export default __webpack_public_path__ + "static/media/other12.8702c25f.webp";